module.exports = __webpack_public_path__ + "static/cover-1dde9d5cddfba02045a1162d671c0f67.jpeg";